<script setup>
import { inject } from 'vue'
import { useClassStore } from '@/stores/ClassStore'

const classStore = useClassStore()

const siteConfig = inject('siteConfig')
// eslint-disable-next-line no-unused-vars
const props = defineProps(['classDetails'])


</script>

<template>
  <h1 class="class-name heading-3 xl:heading-1" v-html="classDetails.shortTitle"></h1>

  <p class="class-code" v-if="siteConfig.features.showClassCodes">
    <Icon icon="ant-design:barcode-outlined" class="icon" />
    <span v-html="classDetails.code"></span>
  </p>

  <p class="class-instructor" v-if="classDetails.instructorSummary">
    <Icon icon="ant-design:user-outlined" class="icon" />
    <span v-html="classDetails.instructorSummary"></span>
  </p>

  <p class="class-schedule" v-if="!siteConfig.features.hideClassDate">
    <Icon icon="ci:calendar" class="icon" />
    <span v-html="classDetails.dateSummary"></span>
  </p>

  <p class="class-schedule" v-if="!siteConfig.features.hideClassTime">
    <Icon icon="ci:clock" class="icon" />
    <span v-html="classDetails.timeSummary"></span>
  </p>

  <p class="class-code" v-if="siteConfig.features.showProgramNameInSummary && classStore.programsById[classDetails.eventId]">
    <Icon icon="ant-design:hourglass-outlined" class="icon" />
    <span v-html="classStore.programsById[classDetails.eventId].title"></span>
  </p>

  <p class="class-location" v-if="!siteConfig.features.hideClassLocation">
    <Icon icon="carbon:location" class="icon" />
    <span v-html="siteConfig.features.useLocationTypeForLocation ? classDetails.locationType : classDetails.location"></span>
  </p>
  
  <p class="class-level">
    <Icon icon="carbon:meter-alt" class="icon" />
    <span v-html="classDetails.classLevel + (classDetails.ages ? `, ${classDetails.ages}` : '')"></span>
  </p>
</template>
